import React from "react";
import { Col, Container as GridContainer, Row } from "react-native-flex-grid";
import { useDeleteUserByIdMutation, useGetGroupByIdQuery, useGetUserQuery, usePutGroupByIdMutation } from "store/abcoApi";

import { useToken } from "@gluestack-style/react";
import TreeGroupNodeWithPermissions from "components/admin/TreeGroupNodeWithPermissions";
import PageLoader from "components/general/PageLoader";
import { Tab, TabContainer } from "components/general/Tabs";
import Pagination from "components/navigation/Pagination";
import { Box, HStack, Link, Text } from "components/ui";
import { AtSign, Info, Trash2, User } from "lucide-react-native";
import { useIsMobile } from "utils/hooks/useIsMobile";
import { UserSelect } from "components/form/UserSelect";
import { useLocalSearchParams } from "expo-router";
import Seo from "components/general/Seo";
import PressableArea from "components/ui/PressableArea";
export default function Page() {
	const [pageNumber, setPageNumber] = React.useState(1);
	const resolvedPrimarylight = useToken("colors", "primarylight");
	const { data, isLoading, isFetching } = useGetUserQuery({ pageNumber });
	const [deleteUser] = useDeleteUserByIdMutation();
	const isMobile = useIsMobile();
	if (isLoading || data == null) {
		return (
			<Box minHeight={150}>
				<PageLoader />
			</Box>
		);
	}
	if (isMobile) {
		return (
			<Box>
				<TabContainer tabTitleSize="full">
					<Tab title="All users" id="all-users">
						<Box paddingVertical={24}></Box>
					</Tab>
					<Tab title="Access" id="access">
						<Box paddingVertical={24}>
							{/* if (isMobile) {
										return (
											<Row style={{ marginLeft: 0, marginRight: 0, gap: 12, paddingHorizontal: 16, paddingVertical: 18, borderRadius: 8, borderWidth: 1, marginBottom: 14, borderColor: "#E1E9F0" }} key={site.id}>
												<Col style={{ justifyContent: "center" }} xs={12}>
													<HStack gap={8}>
														<ListTree size={24} color={resolvedPrimarylight} />
														<Text>{site.groupName}</Text>
													</HStack>
												</Col>
												<Col style={{ justifyContent: "center" }} xs={12}>
													<Link href={`/sites/${site.id}`} key={site.id}>
														<HStack gap={8}>
															<MapPinned style={{ flex: 1, maxWidth: 24 }} width={24} color={resolvedPrimarylight} />
															<Text color="$primarylight" textDecorationLine="underline" flex={1}>
																{site.name}
															</Text>
														</HStack>
													</Link>
												</Col>
												<Col style={{ justifyContent: "center" }} xs={12}>
													<HStack gap={8} alignItems="center">
														<MapPin size={24} color={resolvedPrimarylight} />
														<Text>{site.suburb}</Text>
													</HStack>
												</Col>
												<Col style={{ justifyContent: "center" }} xs={12}>
													<HStack gap={8} alignItems="center">
														<Box marginRight={"auto"}>
															<BudgetProgress currentBudget={938} totalBudget={3000} />
														</Box>
													</HStack>
												</Col>
											</Row>
										);
									} */}
						</Box>
					</Tab>
					<Tab title="Import" id="import">
						<Box paddingVertical={24}></Box>
					</Tab>
				</TabContainer>
			</Box>
		);
	}
	return (
		<Box>
			<Seo title="Admin | Users | Abconet" description="Manage user accounts and permissions for the Abconet platform." />
			<TabContainer>
				<Tab title="All users" id="all-users">
					<Box paddingVertical={24}>
						<GridContainer
							noPadding
							style={{
								marginLeft: 0,
								width: "100%",
								maxWidth: "100%",
							}}
						>
							{!isMobile && (
								<Row style={{ marginLeft: 0, marginRight: 0, marginBottom: 14, width: "100%", paddingHorizontal: 16 }}>
									<Col style={{ justifyContent: "center" }} xs={12} md={2}>
										<Text color="$neutral500">First name</Text>
									</Col>
									<Col xs={12} md={4}>
										<Text color="$neutral500">Last name</Text>
									</Col>
									<Col style={{ justifyContent: "center" }} xs={12} md={3}>
										<Text color="$neutral500">Email</Text>
									</Col>
								</Row>
							)}

							{data?.list &&
								data?.list?.map((user) => {
									return (
										<Link
											href={"/admin/users/" + user.id}
											key={user.id}
											component={(hovered: boolean) => {
												var styleData = { marginLeft: 0, marginRight: 0, paddingHorizontal: 16, paddingVertical: 18, borderRadius: 8, borderWidth: 1, marginBottom: 14, borderColor: "#E1E9F0" };

												if (hovered) {
													// @ts-ignore
													styleData = { ...styleData, backgroundColor: "#E1E9F0" };
												}
												return (
													<Row style={styleData} key={user.id}>
														<Col style={{ justifyContent: "center" }} xs={2} md={2}>
															<HStack gap={8}>
																<User size={24} color={resolvedPrimarylight} />
																{/* <ListTree size={24} color={resolvedPrimarylight} /> */}
																<Text>{user.firstName}</Text>
															</HStack>
														</Col>
														<Col style={{ justifyContent: "center" }} xs={4} md={4}>
															<HStack gap={8}>
																{/* <MapPinned style={{ flex: 1, maxWidth: 24 }} width={24} color={resolvedPrimarylight} /> */}
																<Text flex={1}>{user.lastName}</Text>
															</HStack>
														</Col>
														<Col style={{ justifyContent: "left" }} xs={3} md={5}>
															<HStack gap={8} alignItems="center">
																<AtSign style={{ minWidth: 24 }} width={24} color={resolvedPrimarylight} />
																{/* <MapPin size={24} color={resolvedPrimarylight} /> */}
																<Text>{user.email}</Text>
															</HStack>
														</Col>

														<Col style={{ justifyContent: "center" }} xs={1} md={1}>
															<PressableArea
																onPress={(ev) => {
																	ev.preventDefault(); // Prevent default behavior (navigation)
																	ev.stopPropagation(); // Stop event from propagating to parent
																	deleteUser({ id: user.id });
																}}
																component={(hovered: boolean) => <Trash2 size={24} color={resolvedPrimarylight} opacity={hovered ? 1 : 0.5} />}
															></PressableArea>
														</Col>
													</Row>
												);
											}}
										></Link>
									);
								})}
						</GridContainer>
					</Box>
					<Box alignItems="center">
						<Pagination pageCount={data.metaData?.pageCount} pageNumber={data.metaData?.pageNumber} onChangePage={setPageNumber} />
					</Box>
				</Tab>
				{/* <Tab title="User access" id="user-access">
					<Box padding={24} borderRadius={8} bg="$neutral25" flexDirection="row" gap={8} paddingVertical={15} justifyContent="center" alignItems="center" mb={32}>
						<UserSelect
							isFluid
							value={group?.userGroup?.userCollection ?? []}
							onSelect={(newValue) => {
								// handleUserChange(newValue, group?.name ?? "");
							}}
						/> 
					</Box>
					<Box borderRadius={8} bg="$neutral25" flexDirection="row" gap={8} paddingVertical={15} justifyContent="center" alignItems="center" mb={32}>
						<Info size={24} color={resolvedPrimarylight} />
						<Text fontSize={18} fontFamily="calibri">
							Review and edit the access of this user. And you can add more users.
						</Text>
					</Box>
					<TreeGroupNodeWithPermissions />
				</Tab>
				<Tab title="Import users" id="import-users">
					<Text>View</Text>
				</Tab> */}
			</TabContainer>
		</Box>
	);
}
